import { render } from "./ModelCanvas.vue?vue&type=template&id=45a56efc"
import script from "./ModelCanvas.vue?vue&type=script&lang=js"
export * from "./ModelCanvas.vue?vue&type=script&lang=js"

import "./ModelCanvas.vue?vue&type=style&index=0&id=45a56efc&lang=css"
script.render = render

export default script